import { SET_FILTERS_CLIENTS } from '../actions/filters';

const initialState = {
    text: '',
    identifier: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_FILTERS_CLIENTS: {
            return {
                ...state,
                text: action.payload.text,
                identifier: action.payload.identifier
            };
        }
        default:
            return state;
    }
};
